import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inner-banner',
  templateUrl: './inner-banner.component.html',
  styleUrls: ['./inner-banner.component.scss']
})
export class InnerBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
